export default __webpack_public_path__ + "../staticImages/mann_fernrohr-260.png";